module.exports = __webpack_public_path__ + "static/media/faveats-map-selector.b6517301.png";